import React from 'react';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import {classes} from './PriceBreakdown.st.css';
import {Divider} from '@wix/wix-ui-tpa/cssVars';
import {CouponTotal} from '../../../../../common/components/CouponTotal/CouponTotal';
import {PriceBreakdownSkeleton} from './Skeleton/Skeleton';
import {SubtotalAmount} from './SubtotalAmount/SubtotalAmount';
import {Discounts} from '../../../../../common/components/Discounts/Discounts';

export enum PriceBreakdownDataHooks {
  priceBreakdownDivider = 'PriceBreakdown.priceBreakdownDivider',
  priceBreakdownContainer = 'PriceBreakdown.priceBreakdownContainer',
  priceBreakdownSkeleton = 'PriceBreakdown.priceBreakdownSkeleton',
}

export const PriceBreakdown = () => {
  const {
    cartModel,
    cartSummary: estimatedTotals,
    isSummaryUpdating,
    revampDiscountsInCartAndCheckout,
  } = useControllerProps().cartStore;
  const {shouldDisplaySummaryDiscounts} = useControllerProps().orderStore;

  const appliedCoupon = cartModel.coupon;
  const isCouponApplied = !!appliedCoupon;
  const shouldShowBreakdown = revampDiscountsInCartAndCheckout ? shouldDisplaySummaryDiscounts : isCouponApplied;
  const subtotalAmount =
    estimatedTotals?.priceSummary.subtotal.formattedConvertedAmount ?? cartModel.subtotal?.formattedConvertedAmount;

  return (
    <div>
      {shouldShowBreakdown && (
        <>
          <Divider className={classes.divider} data-hook={PriceBreakdownDataHooks.priceBreakdownDivider} />
          <div className={classes.container} data-hook={PriceBreakdownDataHooks.priceBreakdownContainer}>
            {isSummaryUpdating ? (
              <PriceBreakdownSkeleton />
            ) : (
              <>
                <SubtotalAmount subtotalAmount={subtotalAmount} />
                {revampDiscountsInCartAndCheckout ? (
                  <Discounts shouldShowDivider={false} />
                ) : (
                  <CouponTotal shouldShowDivider={false} />
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};
